<form (ngSubmit)="onSave()" #profileForm="ngForm" class="flex flex-col gap-5">
  <div class="flex flex-col gap-2">
    <label for="fullName" class="font-semibold">Full Name <span class="text-red-500">*</span></label>
    <input
      pInputText
      id="fullName"
      [(ngModel)]="formData.fullName"
      name="fullName"
      placeholder="Enter your full name"
      [class.ng-invalid]="formErrors['fullName']"
      [class.ng-dirty]="formErrors['fullName']"
      class="w-full"
      required />
      @if (formErrors['fullName']) {
        <small class="p-error">{{ formErrors['fullName'] }}</small>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label for="position" class="font-semibold">Position</label>
      <input
        pInputText
        id="position"
        [(ngModel)]="formData.position"
        name="position"
        placeholder="Enter your position"
        class="w-full" />
      </div>

      <div class="flex flex-col gap-2">
        <label for="currentPassword" class="font-semibold">Current Password</label>
        <p-password
          inputId="currentPassword"
          [(ngModel)]="formData.currentPassword"
          name="currentPassword"
          placeholder="Enter current password to change"
          [class.ng-invalid]="formErrors['currentPassword']"
          [class.ng-dirty]="formErrors['currentPassword']"
          [toggleMask]="true"
          styleClass="w-full"
          inputStyleClass="w-full">
        </p-password>
        @if (formErrors['currentPassword']) {
          <small class="p-error">{{ formErrors['currentPassword'] }}</small>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label for="newPassword" class="font-semibold">New Password</label>
        <p-password
          inputId="newPassword"
          [(ngModel)]="formData.newPassword"
          name="newPassword"
        placeholder="Enter new password"
        [class.ng-invalid]="formErrors['newPassword']"
        [class.ng-dirty]="formErrors['newPassword']"
        [toggleMask]="true"
          styleClass="w-full"
          inputStyleClass="w-full">
        </p-password>
        @if (formErrors['newPassword']) {
          <small class="p-error">{{ formErrors['newPassword'] }}</small>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label for="confirmPassword" class="font-semibold">Confirm Password</label>
        <p-password
          inputId="confirmPassword"
          [(ngModel)]="formData.confirmPassword"
          name="confirmPassword"
        placeholder="Confirm new password"
        [class.ng-invalid]="formErrors['confirmPassword']"
        [class.ng-dirty]="formErrors['confirmPassword']"
        [toggleMask]="true"
          styleClass="w-full"
          inputStyleClass="w-full">
        </p-password>
        @if (formErrors['confirmPassword']) {
          <small class="p-error">{{ formErrors['confirmPassword'] }}</small>
        }
      </div>

      <div class="flex justify-end gap-2 pt-4">
        <p-button
          label="Cancel"
          severity="secondary"
          (onClick)="onClose()"
          type="button">
        </p-button>
        <p-button
          label="Save Profile"
          [loading]="loading"
          type="submit"
          icon="pi pi-check">
        </p-button>
      </div>
    </form>
